import compareVersions, {
    VERSION_CM_14830_SEPARATION_OF_OWNER_AND_CREATOR,
} from "@cores/version";

export const isOwnerLockBlockedForUser = (item, stage) => {
    if (!item?.isOwnerLocked) return false;

    const ownerId =
        compareVersions(stage?.version, VERSION_CM_14830_SEPARATION_OF_OWNER_AND_CREATOR) < 0
            ? item.createdBy?.id
            : item.owner?.id;

    return ownerId !== stage?.user?.id;
};

export const hasAnyOwnerLockBlocked = (items, stage) =>
    (items || []).some((item) => isOwnerLockBlockedForUser(item, stage));
